import React from 'react';
import dynamic from 'next/dynamic';
import { AdUnits } from '../../../common/helpers/ads/dfp';
import { isDesktop } from '../../../common/helpers/utility/screenHelper';
import { Wrapper } from './ProjectOtherContent.style';
import { PostProject } from '../../../queries/contentPage/postDetail';

// Importing ads components dynamically to avoid loading them in the server side rendering
const HalfPageAds = dynamic(() => import('../../ads/HalfPageAds'), {
  ssr: false,
});

interface ProjectOtherContentProps {
  loading: boolean;
  deviceType: string;
  sect: string[] | string;
  project: PostProject;
  isOnProjectPage?: boolean;
}
const ProjectOtherContent: React.FC<ProjectOtherContentProps> = ({
  loading,
  deviceType,
  sect,
  project,
}) => {
  return (
    <Wrapper>
      {!loading && isDesktop(deviceType) && (
        <HalfPageAds
          project={project}
          adUnit={AdUnits.PP_HalfPageAd}
          sect={sect}
        />
      )}
    </Wrapper>
  );
};

export default ProjectOtherContent;
